import { Component, ReactNode } from 'react';

type ErrorBoundaryProps = {
	children: ReactNode;
};

type ErrorBoundaryState = {
	hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state to show fallback UI on error
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo) {
		// Log the error to an error reporting service or console
		console.error('Hiba történt:', error, info);
	}

	render() {
		if (this.state.hasError) {
			return <h1>Hiba történt a betöltéskor.</h1>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
